export default "__VITE_ASSET__BRZM0y1F__"